import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as userActions from "../../_actions/userActions";
import * as notificationActions from "../../_actions/notificationActions";
import isSidebarMinimized from "../../_selectors/appSelectors/isSidebarMinimized";
import isSidebarCollapsed from "../../_selectors/appSelectors/isSidebarCollapsed";
import isRightBarOpen from "../../_selectors/appSelectors/isRightBarOpen";
import PageHeader from "../../_components/Layout/PageHeader";
import Sidebar from "../../_components/Layout/Sidebar";
import RightSidebar from "../../_components/Layout/RightSidebar";
import Footer from "../../_components/Layout/Footer";
import Content from "../../_components/Layout/Content";
import ToastContainer from "../../_components/Layout/ToastContainer";
import PageTitle from "../../_components/Layout/PageTitle";
import Modal from "react-responsive-modal";
import AccountCreatedModal from "../../_components/UI/AccountCreatedModal";
import showNewAccountCreatedModal from "../../_selectors/userSelectors/showNewAccountCreatedModal";

class Layout extends Component {
  state = { open: false };
  componentDidMount() {
    const {
      getUserProfileData,
      getNotifications,
      history,
      getMobileNumber,
      getPrivacy
    } = this.props;
    //this.unsubscribeProfile = getUserProfileData();
    //this.unsubscribeNotifications = getNotifications({ history });
    // this.unsubscribeMobileNumber = getMobileNumber();
    // this.unsubscribePrivacy = getPrivacy();
  }
  componentWillUnmount() {
    try {
      // this.unsubscribeNotifications();
      // this.unsubscribeProfile();
      // this.unsubscribeMobileNumber();
      // this.unsubscribePrivacy();
    } catch (error) {
      //nothing
    }
  }
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };
  render() {
    const {
      isSidebarMinimized,
      isSidebarCollapsed,
      isRightBarOpen,
      children,
      showNewAccountCreatedModal
    } = this.props;
    let _classNames = ["dev-page", "dev-page-loaded"];
    isSidebarMinimized ? _classNames.push("dev-page-sidebar-minimized") : null;
    isSidebarCollapsed ? _classNames.push("dev-page-sidebar-collapsed") : null;
    isRightBarOpen ? _classNames.push("dev-page-rightbar-open") : null;
    return (
      <div className={_classNames.join(" ")}>
        <PageHeader />
        <div className="dev-page-container">
          <Content>
            <PageTitle />
            {children}
          </Content>
        </div>
        <Footer />
        <ToastContainer />
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  isSidebarMinimized: isSidebarMinimized(state),
  isSidebarCollapsed: isSidebarCollapsed(state),
  isRightBarOpen: isRightBarOpen(state),
  showNewAccountCreatedModal: showNewAccountCreatedModal(state)
});
const mapDispatchToProps = dispatch => ({
  getUserProfileData: () => dispatch(userActions.getUserProfile()),
  getMobileNumber: () => dispatch(userActions.getMobileNumber()),
  getNotifications: payload =>
    dispatch(notificationActions.listeningForNewNotification(payload)),
  getPrivacy: () => dispatch(userActions.getPrivacySetting())
});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Layout)
);



// WEBPACK FOOTER //
// ./src/_hoc/Layout/index.js